<div style="margin-top: 30px;text-align: center;">
  <h1>{{'Induction Search' | translate | async}}</h1>
</div>

<mat-card style="margin-left: 10px;margin-right: 10px;margin-top: 10px;" *ngIf="loading != true">


  <div class="toolset" style="padding: 2%;">

    <!--TT-5145-->
<mat-card >

  <div class="search-options"
    style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">
    
    
    <mat-form-field class="header-form-full-width">
      <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date' | translate | async}}" [(ngModel)]="StartDate">
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date' | translate | async}}" [(ngModel)]="EndDate">
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <mat-select *ngIf="DataForSearch" (selectionChange)="changeInductionType($event.value)"
        placeholder="{{'Select Induction Type' | translate | async}}" [(ngModel)]="InductionType">
        <mat-option *ngFor="let _type of DataForSearch.InductionTypes" [value]="_type.ID">
          {{_type.Title}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <mat-select *ngIf="DataForSearch" (selectionChange)="changeState($event.value)"
        placeholder="{{'Select State'| translate | async}}" [(ngModel)]="State">
        <mat-option *ngFor="let _type of DataForSearch.States" [value]="_type.ID">
          {{_type.SideCode}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <mat-label>{{'First Name' | translate | async}}</mat-label>
      <input  type="text" matInput placeholder="{{'First Name' | translate | async}}" [(ngModel)]="Fname"
       >
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <mat-label >{{'Last Name' | translate | async}}</mat-label>
      <input  type="text" matInput placeholder="{{'Last Name' | translate | async}}" [(ngModel)]="Lname"
        >
    </mat-form-field>
    <mat-form-field class="header-form-full-width">
      <mat-label >{{'Email Address' | translate | async}}</mat-label>
      <input  type="text" matInput placeholder="{{'Email Address'| translate | async}}"
        [(ngModel)]="Email">
    </mat-form-field>
    <mat-form-field class="header-form-full-width">
      <mat-label>{{'Company' | translate | async}}</mat-label>
      <input type="text" matInput placeholder="{{'Company'| translate | async}}" [(ngModel)]="Company"
       >
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <input type="text" placeholder="{{'Facilitator' | translate | async}}" [(ngModel)]="facilitaorVal" (input)="changeFacilatorAutoComplete($event)" matInput
        [matAutocomplete]="auto">
      <mat-autocomplete [(ngModel)]="facilitaorTitle" #model_auto="ngModel" #auto="matAutocomplete"
        (optionSelected)="facilitaorselect($event.option.value)">
        <mat-option [value]="_type[0].FullName" *ngFor="let _type of facilitatorListSortedNew">
          {{_type[0].FullName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div style="display: flex;">
    <div class="search-options-cell" style="display: flex;    margin-left: 7px;">
      <mat-checkbox style="margin-right: 20px;" [(ngModel)]="ShowValid" (change)="ChangeValid($event)">{{'Show Valid'| translate | async}}</mat-checkbox>
      <mat-checkbox [(ngModel)]="ShowInvallid" (change)="ChangeInvalid($event)">{{'Show Invalid' | translate | async}}</mat-checkbox>
    </div>


    <div class="search-options-cell">
      <div style="display: flex;flex-direction: row;justify-content: flex-end;">
          <a class="button " (click)="OnClickReset()">
          <span class="button__text">{{'Reset' | translate | async}}</span>
        </a>
        <a style="margin-left: 30px;" class="button button--primary" (click)="OnClickSearch()">
          <span class="button__text">{{'Search' | translate | async}}</span>
        </a>
      </div>
  </div>

  </div>

</mat-card>




    <div style="margin-top: 20px;">

      <div style="margin-left: 44%;" *ngIf="loadingSearch">
        <mat-spinner> </mat-spinner>
    </div>

    <div  *ngIf="ShowNodData">
      <span style="font-size:large ; font-weight:bold ;">{{'No Data Found - Please reset and try again.' | translate | async}}</span>
  </div>

  <button mat-raised-button color="warn"  style="float: right;margin-right: 2%;" (click)="DownloadCSVFile()"><span class="material-icons button__icon">save_alt</span></button>

      <mat-table class="table-material table-material--striped table-material--hover table-material--full-width" #table
        [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="Date">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Date' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Date}}">
            <div> {{element.Date}} </div>
          </mat-cell>

        </ng-container>

        <ng-container matColumnDef="facilitatorName">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Facilitator' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.facilitatorName}}">
            <div> {{element.facilitatorName}} </div>
          </mat-cell>

        </ng-container>
        <ng-container matColumnDef="Fname">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'First Name' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Fname}}">
            <div class="SerialAndUnitText"> {{element.Fname}} </div>
          </mat-cell>

        </ng-container>
        <ng-container matColumnDef="Lname">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Last Name' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Lname}}">
            <div class="SerialAndUnitText"> {{element.Lname}} </div>
          </mat-cell>

        </ng-container>

        <ng-container matColumnDef="Email">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Email' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Email}}">
            <div class="SerialAndUnitText">{{element.Email}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="InductionType">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Induction Type' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.InductionType}}">
            <div class="SerialAndUnitText">{{element.InductionType}} </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Company">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Company' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Company}}">
            <div class="SerialAndUnitText">{{element.Company}} </div>
          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="State">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'State' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.State}}">
            <div class="SerialAndUnitText" style="width: 75px;"> {{element.State}} </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="IsValid">
          <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'VALID' | translate | async}}
          </mat-header-cell>
          <mat-cell class="customWidthClass" *matCellDef="let element">
            <div *ngIf="element.IsValid == true" class="SerialAndUnitText" style="width: 75px;"> {{'YES' | translate | async}} </div>
            <div *ngIf="element.IsValid != true" class="SerialAndUnitText" style="width: 75px;"> {{'NO' | translate | async}} </div>

          </mat-cell>
        </ng-container>



        <mat-header-row *matHeaderRowDef="displayedColumns; "></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; " (click)="navigatetoUploadForm(row)"
          style="cursor: pointer;"></mat-row>
      </mat-table>
    </div>


  </div>

</mat-card>






<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 800px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>